import {AppError, Alert} from '@/shared/models';
import {AuthApi} from '@/shared/services';
import { UsersApi } from '@/shared/services'

export const actions = {
    async authCheck({commit, getters}, $route){

        //check if token set in query
        let accessToken = null;
        const token = $route.query.token;
        console.log("authCheck",token,$route)
        if (token) {
            accessToken = {value: token, type: 'JSESSIONID'};
        }else{
            // check if already set in store
            accessToken = getters['accessToken'];
        }

        if(accessToken){
            console.log("setAccessToken",accessToken,$route)
            commit('setAccessToken', accessToken);
            // retrieve user
            try {
                const user = await UsersApi.me(accessToken);
                commit('setLoggedUser', user);
                return user;
            }catch(error) {
                commit('setLoggedUser', null);
                commit('setAccessToken', null);
                return error;
            }
        }else{
            // no token in query and in store throw error
            commit('setLoggedUser', null);
            commit('setAccessToken', null);
            throw new AppError('AccessToken not found');
        }
    },
    async logout({commit}){
        await AuthApi.logout();
        // redirect to default route
        router.push('/');
        commit('setAccessToken', null);
        commit('setLoggedUser', null);
    }
};
